/**
 * True when the URL path ends with ".pdf" (no junk like " (2)" after it).
 * Browsers often force-download PDF iframe embeds when the path does not end in .pdf,
 * even if Content-Type is application/pdf.
 */
export const hasCleanPdfPath = (urlOrPath = "") => {
  if (!urlOrPath) {
    return false;
  }

  let path = String(urlOrPath);

  try {
    path = new URL(path, "https://example.com").pathname;
  } catch {
    path = path.split("?")[0].split("#")[0];
  }

  try {
    path = decodeURIComponent(path);
  } catch {
    // Keep the undecoded path.
  }

  return /\.pdf$/i.test(path);
};

/**
 * iframe src for inline PDF preview.
 * Returns empty string when the path is unsafe to embed (would trigger a download).
 */
export const getPdfEmbedUrl = (fileUrl = "") => {
  if (!fileUrl || !hasCleanPdfPath(fileUrl)) {
    return "";
  }

  const separator = fileUrl.includes("#") ? "&" : "#";
  return `${fileUrl}${separator}page=1&toolbar=0&navpanes=0&scrollbar=1&view=FitH`;
};

/** target=_blank href for the Preview action */
export const getPdfPreviewLink = (fileUrl = "") => fileUrl || "";
